<template>
  <div class="flex flex-col gap-2">
    <div class="inline-flex gap-2 w-full" :class="!edit ? 'border rounded border-gray-500/25 p-2':''">
      <CheckboxDetail
        v-if="type == 'checkbox'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <CheckboxGroupDetail
        v-else-if="type == 'checkbox_group'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <DateTimeDetail
        v-else-if="['date', 'datetime'].includes(type)"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <MultiselectDetail
        v-else-if="type == 'multiselect'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <RadioDetail
        v-else-if="type == 'radio'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <NumberDetail
        v-else-if="type == 'number'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <FileDetail
        v-else-if="type == 'file'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
        :procedure="procedure"
        @deleted="$emit('deleted', $event)"
      />

      <SelectDetail
        v-else-if="type == 'select'"
        v-bind="$attrs"
        :value="value"
        :edit="edit"
        :original="original"
        :procedure="procedure"
      />

      <TextDetail
        v-else
        v-bind="$attrs"
        :type="type"
        :value="value"
        :edit="edit"
        :original="original"
      />

      <rpm-button
        icon="fa-solid fa-pen-to-square"
        color="transparent"
        @click="edit = true"
      ></rpm-button>
    </div>
    <div v-if="edit" class="flex flex-row justify-center gap-4">
      <rpm-button
        label="cancelar"
        color="gray"
        @click="$emit('update:modelValue', value), edit = false"
      ></rpm-button>

      <rpm-button
        label="confirmar"
        color="theme"
        @click="$emit('confirm', id), edit = false"
      ></rpm-button>
    </div>
  </div>
</template>


<script>

import CheckboxDetail from "./CheckboxDetail.vue";
import CheckboxGroupDetail from "./CheckboxGroupDetail.vue";
import DateTimeDetail from "./DateTimeDetail.vue";
import MultiselectDetail from "./MultiselectDetail.vue";
import RadioDetail from "./RadioDetail.vue";
import TextDetail from "./TextDetail.vue";
import NumberDetail from "./NumberDetail.vue";
import FileDetail from "./FileDetail.vue";
import SelectDetail from "./SelectDetail.vue";

export default {
  name: "Details",
  inheritAttrs: false,
  components: {
    CheckboxDetail,
    CheckboxGroupDetail,
    DateTimeDetail,
    MultiselectDetail,
    RadioDetail,
    TextDetail,
    NumberDetail,
    FileDetail,
    SelectDetail
  },
  data() {
    return {
      edit: false
    }
  },
  props: {
    value: {
      required: true,
    },
    procedure: {
      type: Object,
      required: true,
    },
    original: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    }
  },
};

</script>
